<template>
    <v-overlay
        v-model="display">
        <v-sheet class="pa-4" width="300" rounded="lg" color="white">
            <v-row no-gutters
                class="fill-height"
                align-content="center"
                justify="center">
                <v-col cols="12">
                    <v-progress-linear
                        indeterminate
                        rounded
                        height="6"
                    ></v-progress-linear>
                </v-col>
                <v-col
                    class="text-center primary--text mt-2"
                    cols="12">
                    {{ message }}
                </v-col>
            </v-row>
        </v-sheet>
    </v-overlay>
</template>

<script>
export default {
    name: "LoadingDialog",
    props: {
        message: {
            type: String,
            required: true
        },
        value: Boolean
    },
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    }
}
</script>